import { forwardRef } from 'react';
import { MapPin } from 'lucide-react';
import { SectionAtmosphere } from '../layout/HoldingBackdrop';

const Locations = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} id="office" className="relative isolate overflow-hidden px-5 py-24 md:px-8 md:py-28">
      <SectionAtmosphere variant="locations" />
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-semibold tracking-[-0.04em] text-[#f1f5ec]/90 md:text-5xl">
            Headquarters
          </h2>
          <p className="mt-5 text-base leading-8 text-[#d6ddcf]/85 md:text-lg">
            Fidus Finance is a Brazilian company. Our headquarters are in Florianópolis, Brazil.
          </p>
        </div>
        <div className="mx-auto mt-12 max-w-md rounded-3xl border border-[#e8ede4]/10 bg-white/[0.035] px-8 py-10 text-center">
          <MapPin className="mx-auto mb-3 h-8 w-8 text-teal-200/85" aria-hidden />
          <h3 className="font-semibold tracking-[-0.02em] text-[#f1f5ec]/88">Brazil</h3>
          <p className="mt-1 text-sm text-[#d6ddcf]/85">Florianópolis</p>
        </div>
      </div>
    </section>
  );
});

Locations.displayName = 'Locations';
export default Locations;
